import ReactDOM from 'react-dom';

export function createRoot(container) {
  return {
    render(children) {
      ReactDOM.render(children, container);
    },
    unmount() {
      ReactDOM.unmountComponentAtNode(container);
    }
  };
}
